import { Flex, FormLabel } from '@chakra-ui/react'

import { Button, FORM_LABEL_STYLES } from '@/components/ui'

interface FacilitySelectHeaderIProps {
  allFacilitiesSelected: boolean
  onToggleSelectAll: () => void
  isDisabled?: boolean
  dataTestId?: string
}

export const FacilitySelectHeader = ({
  allFacilitiesSelected,
  onToggleSelectAll,
  isDisabled = false,
  dataTestId,
}: FacilitySelectHeaderIProps) => (
  <Flex alignItems='center' justifyContent='space-between' mb='8px'>
    <FormLabel
      color={FORM_LABEL_STYLES.color}
      fontSize={FORM_LABEL_STYLES.fontSize}
      htmlFor='facilities'
      letterSpacing={FORM_LABEL_STYLES.letterSpacing}
      m='0'
      opacity={FORM_LABEL_STYLES.opacity}
    >
      Facilities
    </FormLabel>
    <Button
      _active={{ color: 'brand.200' }}
      _focus={{ outline: 'none' }}
      _hover={{ textDecoration: 'none' }}
      color='brand.200'
      data-testid={dataTestId}
      fontSize='14px'
      height='auto'
      isDisabled={isDisabled}
      minW='auto'
      onClick={onToggleSelectAll}
      p='0'
      textDecoration='none'
      variant='link'
    >
      {allFacilitiesSelected ? 'Deselect All' : 'Select All'}
    </Button>
  </Flex>
)
